(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amlaya-hotspot-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('amlaya-hotspot-banner')) {
    customElements.define(
      'amlaya-hotspot-banner',
      class extends HTMLElement {
        connectedCallback() {
          this.handleClick = (event) => {
            const trigger = event.target.closest('[data-product-dialog]');
            if (trigger && !trigger.disabled) {
              const dialog = document.getElementById(trigger.dataset.productDialog);
              if (dialog && !dialog.open) dialog.showModal();
            }
            const dialog = event.target.closest('dialog');
            if (!dialog) return;
            if (event.target.closest('[data-close]')) dialog.close();
            else if (event.target === dialog) {
              const bounds = dialog.getBoundingClientRect();
              if (
                event.clientX < bounds.left ||
                event.clientX > bounds.right ||
                event.clientY < bounds.top ||
                event.clientY > bounds.bottom
              )
                dialog.close();
            }
          };
          this.addEventListener('click', this.handleClick);
        }
        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amlaya-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('amlaya-reels')) {
    customElements.define('amlaya-reels', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.amlaya-reels__track');
        this.videos = [...this.querySelectorAll('video')];
        this.previous = this.querySelector('[data-direction="previous"]');
        this.next = this.querySelector('[data-direction="next"]');
        this.videos.forEach((video) => {
          video.muted = true;
          const item = video.closest('.amlaya-reels__item');
          const button = item.querySelector('button');
          const update = () => {
            button.setAttribute('aria-pressed', String(!video.paused));
          };
          item.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse') this.playVideo(video);
          }, options);
          item.addEventListener('pointerleave', (event) => {
            if (event.pointerType === 'mouse') video.pause();
          }, options);
          button.addEventListener('click', () => video.paused ? this.playVideo(video) : video.pause(), options);
          button.addEventListener('blur', () => video.pause(), options);
          video.addEventListener('play', update, options);
          video.addEventListener('pause', update, options);
        });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-direction]');
          const card = this.track.firstElementChild;
          if (!button || button.disabled || !card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
          this.track.scrollBy({ left: button.dataset.direction === 'next' ? step : -step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, options);
        this.track.addEventListener('scroll', () => this.updateArrows(), { ...options, passive: true });
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('.amlaya-reels__item');
          if (item) this.track.scrollBy({ left: item.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'instant' });
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.videos.forEach((video) => video.pause());
        }, options);
        this.visibility = new IntersectionObserver((entries) => {
          entries.forEach((entry) => { if (!entry.isIntersecting) entry.target.pause(); });
        });
        this.videos.forEach((video) => this.visibility.observe(video));
        this.resize = new ResizeObserver(() => this.updateArrows());
        this.resize.observe(this.track);
        this.updateArrows();
      }
      playVideo(video) {
        this.videos.forEach((other) => { if (other !== video) other.pause(); });
        video.muted = true;
        video.play().catch(() => {});
      }
      updateArrows() {
        if (!this.previous || !this.next) return;
        this.previous.disabled = this.track.scrollLeft <= 1;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.visibility?.disconnect();
        this.videos?.forEach((video) => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-video-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('background-video-banner')) {
    customElements.define(
      'background-video-banner',
      class extends HTMLElement {
        connectedCallback() {
          this.player = this.querySelector('.video-banner__player');
          if (!this.player) return;
          this.breakpoint = window.matchMedia('(max-width: 749px)');
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.onChange = () => this.loadVideo();
          this.breakpoint.addEventListener('change', this.onChange);
          this.reducedMotion.addEventListener('change', this.onChange);
          this.loadVideo();
        }
        loadVideo() {
          this.video?.pause();
          const template = this.querySelector(this.breakpoint.matches ? '[data-mobile]' : '[data-desktop]');
          this.player.replaceChildren(template.content.cloneNode(true));
          this.video = this.player.querySelector('video');
          this.video.muted = true;
          if (!this.reducedMotion.matches) this.video.play().catch(() => {});
        }
        disconnectedCallback() {
          this.video?.pause();
          this.breakpoint?.removeEventListener('change', this.onChange);
          this.reducedMotion?.removeEventListener('change', this.onChange);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-image-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-image-carousel')) {
    customElements.define('collection-image-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.collection-carousel__track');
        this.previous = this.querySelector('[data-direction="previous"]');
        this.next = this.querySelector('[data-direction="next"]');
        this.onScroll = () => this.updateArrows();
        this.onClick = (event) => {
          const button = event.target.closest('[data-direction]');
          if (!button || button.disabled) return;
          const card = this.track.firstElementChild;
          if (!card) return;
          const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
          this.track.scrollBy({ left: button.dataset.direction === 'next' ? distance : -distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.onBlockSelect = (event) => {
          const card = event.target.closest('.collection-carousel__item');
          if (card && this.contains(card)) {
            this.track.scrollBy({ left: card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'instant' });
          }
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.observer = new ResizeObserver(this.onScroll);
        this.observer.observe(this.track);
        this.updateArrows();
      }
      updateArrows() {
        if (!this.previous || !this.next) return;
        this.previous.disabled = this.track.scrollLeft <= 1;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-color-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-color-carousel')) {
    customElements.define(
      'collection-color-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector(
            '.collection-color-carousel__track'
          );

          this.previous = this.querySelector(
            '[data-direction="previous"]'
          );

          this.next = this.querySelector(
            '[data-direction="next"]'
          );

          this.onScroll = () => this.updateArrows();

          this.onClick = (event) => {
            const button = event.target.closest('[data-direction]');

            if (!button || button.disabled) return;

            const card = this.track.firstElementChild;

            if (!card) return;

            const distance =
              card.getBoundingClientRect().width +
              parseFloat(
                getComputedStyle(this.track).columnGap
              );

            this.track.scrollBy({
              left:
                button.dataset.direction === 'next'
                  ? distance
                  : -distance,

              behavior:
                window.matchMedia(
                  '(prefers-reduced-motion: reduce)'
                ).matches
                  ? 'instant'
                  : 'smooth'
            });
          };

          this.onBlockSelect = (event) => {
            const card = event.target.closest(
              '.collection-color-carousel__item'
            );

            if (card && this.contains(card)) {
              this.track.scrollBy({
                left:
                  card.getBoundingClientRect().left -
                  this.track.getBoundingClientRect().left,
                behavior: 'instant'
              });
            }
          };

          this.addEventListener(
            'click',
            this.onClick
          );

          this.addEventListener(
            'shopify:block:select',
            this.onBlockSelect
          );

          this.track.addEventListener(
            'scroll',
            this.onScroll,
            { passive: true }
          );

          this.observer = new ResizeObserver(
            this.onScroll
          );

          this.observer.observe(this.track);

          this.updateArrows();
        }

        updateArrows() {
          if (!this.previous || !this.next) return;

          this.previous.disabled =
            this.track.scrollLeft <= 1;

          this.next.disabled =
            this.track.scrollLeft +
              this.track.clientWidth >=
            this.track.scrollWidth - 1;
        }

        disconnectedCallback() {
          this.removeEventListener(
            'click',
            this.onClick
          );

          this.removeEventListener(
            'shopify:block:select',
            this.onBlockSelect
          );

          this.track?.removeEventListener(
            'scroll',
            this.onScroll
          );

          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
